export class DebitorModel {
    public DebitorID: number = 0;
    public Nummer: string = "";
    public Name: string = "";
    public Strasse: string | null = null;
    public PLZ: string | null = null;
    public Ort: string | null = null;
    public LandID: number | null = null;
    public EMail: string | null = null;
    public Telefon: string | null = null;
}

export interface DebitorModelView extends DebitorModel {
    LandName: string;
}
